import { PurchaseOrdersStoreModule } from '@/shared';

export default PurchaseOrdersStoreModule;